<template>
  <div class="create-person">
    <Header />
    <Main>
      <h3 class="text-center">Создание личной карточки</h3>
      <b-overlay :show="loading">
        <person-form v-model="personData" class="create-person__form" />
      </b-overlay>
    </Main>
    <bottom-overlay v-if="edited">
      <b-button
        @click="createPerson"
        block
        squared
        variant="success"
        class="create-person__create-button"
        :disabled="loading"
      >
        Создать личную карточку
      </b-button>
    </bottom-overlay>
  </div>
</template>
<script>
import Header from "@/components/Layout/Header";
import Main from "@/components/Layout/Main";
import PersonForm from "@/components/Forms/Person/PersonForm";
import PersonModel from "@/components/Forms/Person/models/personModel";
import BottomOverlay from "@/components/BottomOverlay";
import { mapGetters } from "vuex";
import pageTitleMixin from "@/mixins/pageTitleMixin";
export default {
  components: { BottomOverlay, PersonForm, Main, Header },
  mixins: [pageTitleMixin],
  data() {
    return {
      personData: new PersonModel(),
      loading: false,
      previousRoute: ""
    };
  },
  computed: {
    ...mapGetters("user", ["hasRight", "hasRole"]),
    edited: ({ personData }) =>
      JSON.stringify(personData) !== JSON.stringify(new PersonModel())
  },
  methods: {
    createPerson() {
      this.loading = true;
      this.$store
        .dispatch("people/createPerson", this.personData)
        .then(() => {
          if (this.previousRoute.name === "Create Gym Client")
            this.$router.push(this.previousRoute.path);
          else if (
            this.hasRole(["admin", "root"]) ||
            this.hasRight(["editPerson"])
          )
            this.$router.push(`/people`);
        })
        .catch(() => (this.loading = false));
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.previousRoute = from;
    });
  }
};
</script>

<style lang="scss">
.create-person {
  &__form {
    padding: 5px;
  }
  &__create-button {
    height: 50px;
  }
}
</style>
